import instance from "../interceptors/AxiosInterceptor";

const BASE_URL = "/api/claims";
const claimService = {

    getClaimsByDebtor: async (debtorId) => {
        try {
            const response = await instance.get(`${BASE_URL}/by-debtor/${debtorId}`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getClaimsByContract: async (contractId) => {
        try {
            const response = await instance.get(`${BASE_URL}/by-contract/${contractId}`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getClaimsByUser: async () => {
        try {
            const response = await instance.get(`${BASE_URL}/all`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    addClaim: async (claim) => {
        try {
            const response = await instance.post(`${BASE_URL}/add`, claim, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    generateClaim: async (claim) => {
        try {
            const response = await instance.post(`${BASE_URL}/add-ai`, claim, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    updateClaim: async (claimId, claim) => {
        try {
            const response = await instance.put(`${BASE_URL}/update/${claimId}`, claim, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    deleteClaim: async (claimId) => {
        try {
            const response = await instance.delete(`${BASE_URL}/delete/${claimId}`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

}

export default claimService;